export const CUSTOMER_TYPE = {
  B2B: 'B2B',
  B2C: 'B2C'
}

export const SEE_TUTORIAL_AGAIN_STEP_ID = 'see-tutorial-again'
export const MY_ACCOUNT_NAV_MENU_CLASS = '.rhg-avatar'
export const ACCOUNT_TUTORIAL_TYPES = {
  OFFCANVAS: 'offcanvas',
  NAVBAR: 'navbar',
  NONE: ''
}

export const START_BEHAVIOR = 'start'
export const END_BEHAVIOR = 'end'
export const CENTER_BEHAVIOR = 'center'

export const STEP_TYPES = {
  'off-canvas-loyalty': ACCOUNT_TUTORIAL_TYPES.OFFCANVAS,
  membershipAndTiers: ACCOUNT_TUTORIAL_TYPES.NONE,
  yourBenefits: ACCOUNT_TUTORIAL_TYPES.NONE,
  'My-profile': ACCOUNT_TUTORIAL_TYPES.NAVBAR,
  'My-statements': ACCOUNT_TUTORIAL_TYPES.NAVBAR,
  'My-reservations': ACCOUNT_TUTORIAL_TYPES.NAVBAR
}

export const STEP_SCROLL_POSITION_DESKTOP = {
  'off-canvas-loyalty': CENTER_BEHAVIOR,
  membershipAndTiers: CENTER_BEHAVIOR,
  yourBenefits: START_BEHAVIOR,
  'My-profile': CENTER_BEHAVIOR,
  'My-statements': CENTER_BEHAVIOR,
  'My-reservations': CENTER_BEHAVIOR,
  'see-tutorial-again': CENTER_BEHAVIOR
}

export const STEP_SCROLL_POSITION_RESPONSIVE = {
  'off-canvas-loyalty': START_BEHAVIOR,
  membershipAndTiers: START_BEHAVIOR,
  yourBenefits: START_BEHAVIOR,
  'My-profile': CENTER_BEHAVIOR,
  'My-statements': CENTER_BEHAVIOR,
  'My-reservations': CENTER_BEHAVIOR,
  'see-tutorial-again': START_BEHAVIOR
}

export const DEFAULT_POSITION = 'bottom'

export const OFFCANVAS_LOYALTY_ID = 'off-canvas-loyalty'
export const OFFCANVAS_LOYALTY_OVERFLOW_CLASS = 'overflow-inherit'
export const OFFCANVAS_LOYALTY_CLASS = 'customer-info-modal-content'

export const OFFCANVAS_RESPONSIVE_TARGETID = 'off-canvas-user-profile-responsive'

export const OFFCANVAS_RESPONSIVE_HIGHLIGHTED_ID = 'header'

export const STEP_PROPERTIES = {
  POSITION: 'position',
  HIGHLIGHTED_ID: 'highlightedId',
  TARGET_ID: 'targetId'
}

export const corporateRoles = {
  ADMINISTRATOR: 'administrator',
  DEPUTY: 'deputy',
  BOOKER: 'booker',
  TMC_ADMIN: 'tmc admin',
  TMC_BOOKER: 'tmc booker',
  PCR_ADMIN: 'pcr admin',
  PCR_BOOKER: 'pcr booker'
}

export const memberTypeAccount = {
  PERSONAL: 'PERSONAL',
  CORPORATE: 'CORPORATE',
  BUSINESS: 'BUSINESS'
}

export const adminType = {
  CORPORATE: 'CORPORATE',
  R4U: 'R4U',
  LUSSO: 'LUSSO',
  HYBRID: 'HYBRID'
}

export const programType = {
  RR: 'CORPORATE',
  R4U: 'R4U',
  LUSSO: 'LUSSO',
  ALL: 'ALL'
}

export const PROFILE_TYPES = {
  B2B_ADMIN: 'B2B-A',
  B2B_DEPUTY: 'B2B-DA',
  B2B_TRAVEL_AGENT: 'B2B-TA',
  B2B_MEETINGS_AND_EVENTS: 'B2B-ME',
  PCR_ADMIN: 'PCR-A',
  PCR_MEMBER: 'PCR-B',
  CORP_ADMIN: 'CORP-A',
  TMC_ADMIN: 'TMC-A',
  TMC_MEMBER: 'TMC-B'
}

export const ADMIN_PROFILE_TYPES = [
  PROFILE_TYPES.B2B_ADMIN,
  PROFILE_TYPES.B2B_DEPUTY,
  PROFILE_TYPES.PCR_ADMIN,
  PROFILE_TYPES.CORP_ADMIN,
  PROFILE_TYPES.TMC_ADMIN
]

export const R4U_PROFILE_TYPES = [
  PROFILE_TYPES.PCR_ADMIN,
  PROFILE_TYPES.PCR_MEMBER,
  PROFILE_TYPES.TMC_ADMIN,
  PROFILE_TYPES.TMC_MEMBER
]

export const R4U_ADMIN_PROFILE_TYPES = [
  PROFILE_TYPES.PCR_ADMIN,
  PROFILE_TYPES.TMC_ADMIN
]

export const RR_ADMIN_PROFILE_TYPES = [
  PROFILE_TYPES.B2B_ADMIN,
  PROFILE_TYPES.CORP_ADMIN
]

export const MEMBER_TYPES = {
  CORP_ADMIN: 'corp_admin',
  CORP_DEPUTY: 'corp_deputy',
  CORP_BOOKER: 'corp_booker',
  PCR_ADMIN: 'pcr_admin',
  PCR_BOOKER: 'pcr_booker',
  TMC_ADMIN: 'tmc_admin',
  TMC_BOOKER: 'tmc_booker',
  LUSSO_ADMIN: 'lusso_admin',
  LUSSO_BOOKER: 'lusso_booker'
}

export const LEGACY_MEMBER_TYPES = {
  CORP_ADMIN: 'corpadmin',
  CORP_DEPUTY: 'corpdeputy',
  CORP_BOOKER: 'corpbooker',
  PCR_ADMIN: 'pcradmin',
  PCR_BOOKER: 'pcrbooker',
  TMC_ADMIN: 'tmcadmin',
  TMC_BOOKER: 'tmcbooker',
  LUSSO_ADMIN: 'lussoadmin',
  LUSSO_BOOKER: 'lussobooker'
}

export const R4U_MEMBER_TYPES = [
  MEMBER_TYPES.PCR_ADMIN,
  MEMBER_TYPES.PCR_BOOKER,
  MEMBER_TYPES.TMC_ADMIN,
  MEMBER_TYPES.TMC_BOOKER,
  LEGACY_MEMBER_TYPES.PCR_ADMIN,
  LEGACY_MEMBER_TYPES.PCR_BOOKER,
  LEGACY_MEMBER_TYPES.TMC_ADMIN,
  LEGACY_MEMBER_TYPES.TMC_BOOKER
]

export const R4U_ADMIN_MEMBER_TYPES = [
  MEMBER_TYPES.PCR_ADMIN,
  MEMBER_TYPES.TMC_ADMIN,
  LEGACY_MEMBER_TYPES.PCR_ADMIN,
  LEGACY_MEMBER_TYPES.TMC_ADMIN
]
export const PCR_MEMBER_TYPES = [
  MEMBER_TYPES.PCR_ADMIN,
  MEMBER_TYPES.PCR_BOOKER,
  LEGACY_MEMBER_TYPES.PCR_ADMIN,
  LEGACY_MEMBER_TYPES.PCR_BOOKER
]
export const TMC_MEMBER_TYPES = [
  MEMBER_TYPES.TMC_ADMIN,
  MEMBER_TYPES.TMC_BOOKER,
  LEGACY_MEMBER_TYPES.TMC_ADMIN,
  LEGACY_MEMBER_TYPES.TMC_BOOKER
]
export const LUSSO_MEMBER_TYPES = [
  MEMBER_TYPES.LUSSO_ADMIN,
  MEMBER_TYPES.LUSSO_BOOKER,
  LEGACY_MEMBER_TYPES.LUSSO_ADMIN,
  LEGACY_MEMBER_TYPES.LUSSO_BOOKER
]

export const companyMemberTypes = {
  R4U: R4U_MEMBER_TYPES,
  CORPORATE: [
    MEMBER_TYPES.CORP_ADMIN,
    MEMBER_TYPES.CORP_DEPUTY,
    MEMBER_TYPES.CORP_BOOKER,
    LEGACY_MEMBER_TYPES.CORP_ADMIN,
    LEGACY_MEMBER_TYPES.CORP_DEPUTY,
    LEGACY_MEMBER_TYPES.CORP_BOOKER
  ],
  LUSSO: LUSSO_MEMBER_TYPES
}

export const serviceLineProgramType = {
  CORP: '?memberType=corp',
  B2B: '',
  B2C: {
    vip: '?memberType=B2C&tier=Vip',
    premium: '?memberType=B2C&tier=Premium'
  }
}

export const OFFER_SLIDER_LIMIT = 20
export const DNA_PREFIX = 'DNA-'
